import { Component } from '@angular/core';

@Component({
  selector: 'app-vault-receive-list',
  templateUrl: './vault-receive-list.component.html',
  styleUrl: './vault-receive-list.component.scss'
})
export class VaultReceiveListComponent {

}
